import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalImport } from './local-import.model';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { FileService } from '../../shared/services/file.service';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class LocalLoadImportService {

  private LOCAL_LOAD_IMPORT_URI = 'local-loads/import';

  constructor(private http: HttpClient, private fileService: FileService) {
  }

  public getLastImportForSelfCarrier(): Observable<LocalImport> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOCAL_LOAD_IMPORT_URI}/last/by/carrier/self`;

    return this.http.get(url, { headers })
      .pipe(
        map((result: any) => LocalImport.fromDto(result))
      );
  }

  public getLastImportForCarrier(carrierId: string): Observable<LocalImport> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOCAL_LOAD_IMPORT_URI}/last/by/carrier/${carrierId}`;

    return this.http.get(url, { headers })
      .pipe(
        map((result: any) => LocalImport.fromDto(result))
      );
  }

  public getLastImportsForSelfCarrier(): Observable<LocalImport[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOCAL_LOAD_IMPORT_URI}/get/last10/by/carrier/self`;

    return this.http.get(url, { headers })
      .pipe(
        map((result: any[]) => result.map(i => LocalImport.fromDto(i)))
      );
  }


  public getLastImportsForCarrier(carrierId: string): Observable<LocalImport[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOCAL_LOAD_IMPORT_URI}/get/last10/by/carrier/${carrierId}`;

    return this.http.get(url, { headers })
      .pipe(
        map((result: any[]) => result.map(i => LocalImport.fromDto(i)))
      );
  }

  downloadCsvImportTemplate(): Observable<void> {
    const url = `${URL_BASE}/api/${this.LOCAL_LOAD_IMPORT_URI}/file/template`;

    const headers = HttpUtils.createHeaders();
    headers.set('Accept', 'text/plain');

    return this.http.get(url, { headers, responseType: 'blob', observe: 'response' })
      .pipe(
        flatMap((response: HttpResponse<Blob>) => this.fileService.saveToFileSystem(response))
      );
  }
}
